import { Clone, useAnimations, useGLTF } from "@react-three/drei";
import { useEffect, useRef, useContext } from "react";
import { ViewContext } from "../../../../../providers/View.provider";
import gsap from "gsap";
export default function Turtle() {
  const turtleModel = useGLTF("/models/turtle.glb");
  const turtleAnimations = useAnimations(turtleModel.animations, turtleModel.scene);
  const turtleRef = useRef();
  const groupRef = useRef();
  const { delayNodes } = useContext(ViewContext);
  useEffect(() => {
    gsap.fromTo(groupRef.current.scale, { x: 0, y: 0, z: 0 }, { x: 1, y: 1, z: 1, delay: (delayNodes * 0.1) / 2 });
    turtleAnimations.actions["Scene"].play();
  }, []);
  return (
    <group ref={groupRef}>
      <primitive ref={turtleRef} object={turtleModel.scene} position={[13, 2, -24]} scale={0.41} />
      <Clone object={turtleModel.scene} scale={0.33} position={[13, 0.8, -24.3]} rotation-y={-Math.PI} />
    </group>
  );
}
